import {WindowRefService} from './window-ref.service'
export const config: any = {
    API_URL: 'assets/api',
    GoogleOAuthClientId: '266618811140-qsmo95k0dvn05trvlqihdvq4824o5892.apps.googleusercontent.com',
    FacebookAppId: '616553505899252',
    GtmId: WindowRefService.isModeDev() ? 'GTM-P5BBW6R':'GTM-KKTH9WHX',//GTM-P5BBW6R
};
